import React from "react";
import ReactSVG from "react-svg";

const commonUI = {
  closeButton: <i className="ion-ios-close" />,
  loadingIcon: <ReactSVG src="/classpath/assets/images/loading.svg"/>,
  animationTimeout: 1750
};

export default commonUI;
